<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Title:</label>
        <div>
          <input type="text" placeholder="Title" v-model="editTitle" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Hours per week:</label>
        <div>
          <input type="text" placeholder="Hours per week" v-model="editHours" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Public:</label>
        <div>
          <model-select
            :options="publicOptions"
            v-model="editPublic"
            placeholder="Public"
          ></model-select>
        </div>
      </div>
      <div class="form-inline">
        <label>Requirements and Skills:</label>
        <div>
          <quill-editor
            name="Requirements and Skills"
            :options="editorOption"
            :content="editRequirements"
            v-model="editRequirements"
          />
        </div>
      </div>
      <div class="form-inline flex-row m-t-l">
        <spinnerButton
          class="submit primary"
          :loading="loading"
          @click.native="buttonClick"
          >{{ buttonName }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";
import * as database from "@/vendor/database";
import { randomString } from "@/utils/utils";
import { ModelSelect, MultiSelect } from "vue-search-select";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import moment from "moment-timezone";

export default {
  props: ["propsData", "roleId"],
  components: {
    spinnerButton,
    ModelSelect,
    VueCtkDateTimePicker,
    MultiSelect,
  },
  data() {
    return {
      panelTitle: null,
      buttonName: null,
      loading: false,
      editId: null,
      editTitle: null,
      editHours: null,
      editRequirements: null,
      editPublic: null,
      publicOptions: [
        { text: "true", value: true },
        { text: "false", value: false },
      ],
      editorOption: {
        modules: {
          toolbar: [
            ["link", "bold", "italic", { list: "ordered" }, { list: "bullet" }],
          ],
        },
        theme: "snow",
      },
    };
  },
  created: function () {
    this.initData();
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  methods: {
    initData: function () {
      this.editId = this.propsData.id;
      this.roles = this.propsData.roles;
      if (
        this.roleId !== undefined &&
        this.roleId !== null &&
        this.roles[this.roleId]
      ) {
        this.panelTitle = "Edit Role";
        this.buttonName = "Edit Role";
        this.editTitle = this.roles[this.roleId].title;
        this.editHours = this.roles[this.roleId].hours_per_week;
        this.editRequirements = this.roles[this.roleId].requirements;
        this.editPublic = this.roles[this.roleId].public;
      } else {
        this.panelTitle = "Add Role";
        this.buttonName = "Add Role";
        this.editTitle = null;
        this.editHours = null;
        this.editRequirements = null;
        this.editPublic = null;
      }
      console.log(this.buttonName);
    },
    buttonClick: async function () {
      const roles =
        this.roles && this.roles.length > 0
          ? JSON.parse(JSON.stringify(this.roles))
          : [];
      if (
        this.roleId !== undefined &&
        this.roleId !== null &&
        roles[this.roleId]
      ) {
        roles[this.roleId] = {
          id: roles[this.roleId].id,
          title: this.editTitle ? this.editTitle : null,
          hours_per_week: this.editHours ? this.editHours : null,
          requirements: this.editRequirements ? this.editRequirements : null,
          public: this.editPublic ? this.editPublic : false,
        };
      } else {
        roles.push({
          id: randomString(10),
          title: this.editTitle ? this.editTitle : null,
          hours_per_week: this.editHours ? this.editHours : null,
          requirements: this.editRequirements ? this.editRequirements : null,
          public: this.editPublic ? this.editPublic : false,
        });
      }
      try {
        this.loading = true;
        const result = await database.updateDocById("gigs", this.editId, {
          roles,
        });
        if (result.ok) {
          this.$toasted.global.toast_success({
            message: "success",
          });
          this.$emit("closePanel");
        } else {
          this.$toasted.global.toast_error({ message: "error" });
        }
        this.loading = false;
      } catch {
        this.$toasted.global.toast_error({ message: "error" });
        this.loading = false;
      }
    },
  },
};
</script>
